import { render, staticRenderFns } from "./P02Changepassword.vue?vue&type=template&id=bc7bf540&lang=pug"
import script from "./P02Changepassword.vue?vue&type=script&lang=js"
export * from "./P02Changepassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports